/**
 * Company Zod schemas
 * 
 * Constitution Section 19.4: API Response Validation (Zod Mandatory)
 * All API responses must be parsed and validated with Zod schemas.
 * TypeScript types must be inferred from Zod schemas.
 */

import { z } from 'zod';

/**
 * User role in a company
 */
// Use catch(undefined) so unknown role values don't crash Zod parsing
export const CompanyRoleSchema = z.enum(['OWNER', 'ADMIN', 'MEMBER', 'VIEWER']).catch(undefined as never);

/**
 * Company schema
 * 
 * Based on actual API response structure from /users/me/companies
 */
export const CompanySchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1),
  country_code: z.string().optional(),
  verified: z.boolean().optional(),
  created_at: z.string(), // ISO date string
  role: CompanyRoleSchema.optional(),
});

/**
 * TypeScript type inferred from Zod schema
 */
export type Company = z.infer<typeof CompanySchema>;

/**
 * Array of companies schema
 */
export const CompaniesArraySchema = z.array(CompanySchema);

/**
 * TypeScript type for companies array
 */
export type CompaniesArray = z.infer<typeof CompaniesArraySchema>;
